import * as actionTypes from "@safecv/actions/types";

const initialState = {
  plans: [],
  totalPages: null,
  itemsCountPerPage: null,
  totalItemsCount: 0,
  searchPlans: "",
  spinnerLoading: false,
  filterPlans: "",
  file_type: [],
  pdfTypes: {},
  queryparams: "",
  disciplines: [],
  documentTypes: [],
};

export default function (state = initialState, action) {
  switch (action.type) {
    case actionTypes.FILTER_PLANS_BEGIN:
      return {
        ...state,
        spinnerLoading: true,
      };
    case actionTypes.FILTER_PLANS_SUCCESS:
      return {
        ...state,
        filterPlans: action.payload.text,
        plans: action.payload.planitems,
        totalPages: action.payload.totalPages,
        itemsCountPerPage: action.payload.itemsCountPerPage,
        totalItemsCount: action.payload.totalItemsCount,
        spinnerLoading: false,
      };
    case actionTypes.FILTER_PLANS_FAILURE:
      return {
        ...state,
        spinnerLoading: false,
        error: null,
      };
    case actionTypes.NEW_POST_BEGIN:
      return {
        ...state,
        spinnerLoading: true,
      };
    case actionTypes.NEW_POST_SUCCESS:
      return {
        ...state,
        spinnerLoading: false,
      };
    case actionTypes.NEW_POST_FAILURE:
      return {
        ...state,
        spinnerLoading: false,
      };
    case actionTypes.SEARCH_PLANS:
      return {
        ...state,
        searchPlans: action.payload.text,
        plans: action.payload.items,
        spinnerLoading: true,
      };
    case actionTypes.FILTER_PLANS:
      return {
        ...state,
        filterPlans: action.payload.text,
        plans: action.payload.planitems,
        totalPages: action.payload.totalPages,
        itemsCountPerPage: action.payload.itemsCountPerPage,
        totalItemsCount: action.payload.totalItemsCount,
      };
    case actionTypes.PLANS_DOWNLOAD_BEGIN:
      return {
        ...state,
        pdfTypesLoader: true,
      };
    case actionTypes.PLANS_DOWNLOAD_SUCCESS: {
      let pdfTypes = {};
      action.payload.plan_filetype.map((option) => {
        return (pdfTypes[option.type] = false);
      });
      return {
        ...state,
        pdfTypes: pdfTypes,
        pdfTypesLoader: false,
        file_type: action.payload.plan_filetype,
      };
    }
    case actionTypes.PDF_DOWNLOADER_BEGIN: {
      let pdfType = action.payload.pdfLoaderType.split("=")[1];
      return {
        ...state,
        pdfTypes: {
          ...state.pdfTypes,
          [pdfType]: true,
        },
      };
    }
    case actionTypes.PDF_DOWNLOADER_SUCCESS: {
      let pdfType = action.payload.pdfLoaderType.split("=")[1];
      return {
        ...state,
        pdfTypes: {
          ...state.pdfTypes,
          [pdfType]: false,
        },
      };
    }
    case actionTypes.PDF_DOWNLOADER_FAILURE: {
      let pdfType = action.payload.pdfLoaderType.split("=")[1];
      return {
        ...state,
        pdfTypes: {
          ...state.pdfTypes,
          [pdfType]: false,
        },
      };
    }
    case actionTypes.GRID_COLUMN_CHANGE: {
      return {
        ...state,
        gridOmitColumns: action.payload,
      };
    }

    case actionTypes.PLAN_TYPES: {
      return {
        ...state,
        planTypes: action.payload.planTypes,
      };
    }
    case actionTypes.QUERYPARAMS: {
      return {
        ...state,
        queryparams: action.payload.queryParams,
      };
    }
    case actionTypes.GET_DOCUMENT_TYPES_SUCCESS: {
      return {
        ...state,
        documentTypes: action.payload.documentOptions,
      };
    }
    case actionTypes.GET_DOCUMENT_TYPES_FAILURE: {
      return {
        ...state,
        documentTypes: [],
      };
    }
    default:
      return state;
  }
}
